var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 53.889,
    viewBox: "0 0 59 53.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "free-icon-warning-159469_1_",
    "data-name": "free-icon-warning-159469 (1)",
    transform: "translate(0 -20.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_14260",
    "data-name": "\\uADF8\\uB8F9 14260",
    transform: "translate(0 20.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5891",
    "data-name": "\\uD328\\uC2A4 5891",
    d: "M221.254,333.382a3.029,3.029,0,1,0,0,6.059,3.03,3.03,0,0,0,0-6.059Z",
    transform: "translate(-191.755 -295.513)",
    fill: "rgba(255,255,255,0.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5892",
    "data-name": "\\uD328\\uC2A4 5892",
    d: "M57.564,69.487a10.337,10.337,0,0,0,.024-10.47L38.6,26.153a10.469,10.469,0,0,0-18.168-.012L1.41,59.042a10.5,10.5,0,0,0,9.1,15.729H48.443A10.446,10.446,0,0,0,57.564,69.487ZM53.44,67.112a5.732,5.732,0,0,1-5.009,2.9H10.494a5.654,5.654,0,0,1-4.948-2.836,5.73,5.73,0,0,1-.012-5.78L24.55,28.5a5.714,5.714,0,0,1,9.921.012L53.477,61.4A5.654,5.654,0,0,1,53.44,67.112Z",
    transform: "translate(0 -20.882)",
    fill: "rgba(255,255,255,0.17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5893",
    "data-name": "\\uD328\\uC2A4 5893",
    d: "M220.064,157.262a3.3,3.3,0,0,0-2.339,3.308c.073.957.133,1.927.206,2.884.206,3.648.412,7.222.618,10.87a2.22,2.22,0,0,0,2.266,2.133,2.266,2.266,0,0,0,2.266-2.205c0-.751,0-1.442.073-2.205.133-2.339.279-4.678.412-7.016.073-1.515.206-3.029.279-4.544a3.742,3.742,0,0,0-.279-1.515A3.037,3.037,0,0,0,220.064,157.262Z",
    transform: "translate(-191.316 -140.66)",
    fill: "rgba(255,255,255,0.17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventDashboardIcon);
export default __webpack_public_path__ + "static/media/eventDashboardIcon.4775d282258e3f201433d308b1c109bc.svg";
export { ForwardRef as ReactComponent };